
import React, { useEffect, useLayoutEffect, useState } from "react";
import { getvueAccountObjectPermissionsByAccountIdAndAccountReportIdAsync, checkedState, unCheckedState, UpdatePermissionsAsync } from "./AccountReportPermissionSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { ShowToast } from "../../../common/Toastr";
import Loader from "../../../common/Loader";
import { useTranslation } from "react-i18next";
import { getParentChildPagePermissionsAsync } from '../../../common/GlobalSlice';
import { getValueFromResource } from "../../../common/timeLiveFunction";
const initialValuesForPermissions = {
    IsAccountReportPermissionList: false,
    IsAccountReportPermissionEdit: false
}

export const AccountReportPermission = () => {
    const dispatch = useAppDispatch();
    const { accountReportPermissionList, isReload, selectedRecord, nAccountReportId, nReportName, isLoading } = useAppSelector((state) => state.accountReportPermission)
    // const { state } = useLocation();
    // const { accountReportId } = state;
    // const AccountReportId = accountReportId || '00000000-0000-0000-0000-000000000000';
    const emptyGuid = '00000000-0000-0000-0000-000000000000';
    const location = useLocation();
    // const AccountReportId = (location.state?.accountReportId && location.state?.accountReportId !== '')
    //     ? location.state.accountReportId
    //     : emptyGuid;
     const { AccountReportId } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, maxMenuHeight, sessionAccountEmployeeId } = useAppSelector((state) => state.globalState);
    const [childs, setChilds] = useState(initialValuesForPermissions);
    const Parent_SystemSecurityCategoryPageId: string = "124";
    
    if (AccountReportId === emptyGuid) {
        navigate('/myReports');
    }

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (Parent_SystemSecurityCategoryPageId && Parent_SystemSecurityCategoryPageId !== '') {
                getPermissions(Parent_SystemSecurityCategoryPageId, "125")
            }
        }
        fetchPagePermissions();
    }, [dispatch]);

    const getPermissions = (SystemSecurityCategoryPageId: string, ChildSystemSecurityCategoryPageIds: string) => {
        dispatch(getParentChildPagePermissionsAsync({ SystemSecurityCategoryPageId: SystemSecurityCategoryPageId, ChildSystemSecurityCategoryPageIds: ChildSystemSecurityCategoryPageIds }))
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.ParentPermission) {
                    if (originalPromiseResult.ParentPermission.IsList && originalPromiseResult.ChildPermission) {
                        const childPermission: any = originalPromiseResult.ChildPermission;
                        let foundItem = childPermission.filter((x: any) => x.Id === 125)[0];
                        if (foundItem) {
                            setChilds({
                                ...childs,
                                IsAccountReportPermissionList: foundItem.IsList,
                                IsAccountReportPermissionEdit: foundItem.IsEdit
                            });
                            if (!foundItem.IsList) {
                                navigate('../error/403');
                            }
                        }
                    }
                    else {
                        navigate('../error/403');
                    }
                }
                else {
                    navigate('../error/403');
                }
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    useEffect(() => {
        if (isReload) {
            dispatch(getvueAccountObjectPermissionsByAccountIdAndAccountReportIdAsync(AccountReportId));
        }
    }, [isReload])

    useEffect(() => {
        dispatch(getvueAccountObjectPermissionsByAccountIdAndAccountReportIdAsync(AccountReportId));
    }, [dispatch])

    const handleCheckboxChange = (e: any, index: any, FieldName: string) => {

        if (e.target.checked) {
            dispatch(checkedState({ index: index, FieldName: FieldName }))
        } else {
            dispatch(unCheckedState({ index: index, FieldName: FieldName }))
        }

    };

    const handleOnClickEvent = () => {
        dispatch(UpdatePermissionsAsync({ AccountReportId: AccountReportId, accountReportPermissionList: accountReportPermissionList }))
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.StatusCode === "201") {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast('Report permission updated successfully.', 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                    navigate('/myReports');
                }
            })
            .catch((rejectedValueOrSerializedError) => {
                navigate('/myReports');
            })
    }

    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top fixed-top bg-white">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Report Permission')} */}
                        {getValueFromResource('Report Permission',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        {childs.IsAccountReportPermissionEdit && 
                        <button
                            type="button"
                            className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                            onClick={handleOnClickEvent}
                        >
                            {/* {t('Update')} */}
                            {getValueFromResource('Update',dispatch, t)}
                        </button>
                        }
                    </div>
                </div>
                <div className="card-body mt-3 wizard-overflow-x">
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label htmlFor="ReportName" className="form-label fs-7 fw-normal">
                                {/* {t('Report Id')} */}
                                {getValueFromResource('Report Id',dispatch, t)}
                                </label>
                            <input
                                type="text"
                                id="ReportName"
                                className="form-control fs-7 fw-normal"
                                disabled={true}
                                value={nAccountReportId}
                            />
                        </div>

                        <div className="col-md-6">
                            <label htmlFor="ReportDataSource" className="form-label fs-7 fw-normal">
                                {/* {t('Report Name')} */}
                                {getValueFromResource('Report Name',dispatch, t)}
                                </label>
                            <input
                                type="text"
                                id="ReportName"
                                className="form-control fs-7 fw-normal"
                                disabled={true}
                                value={nReportName}
                            />
                        </div>
                        {/* </div> */}
                    </div>
                    <div className="table-responsive">
                        <table className="table table-row-bordered  align-middle gs-1 gy-3 gx-1" >
                            <thead>
                                <tr className="thHeading align-middle">
                                    <th className='min-w-100px'>
                                        {/* {t('Role')} */}
                                          {getValueFromResource('Role',dispatch, t)}
                                        </th>
                                    <th className='min-w-100px text-center'>
                                        
                                        {/* {t('Show Report')} */}
                                          {getValueFromResource('Show Report',dispatch, t)}
                                        </th>
                                    <th className='min-w-100px text-center'>
                                        
                                        {/* {t('Allow Customization')} */}
                                          {getValueFromResource('Allow Customization',dispatch, t)}
                                        </th>
                                    <th className='min-w-100px text-center'>
                                        
                                        {/* {t('Allow All')} */}
                                          {getValueFromResource('Allow All',dispatch, t)}
                                        </th>
                                    <th className='min-w-100px text-center'>
                                        
                                        {/* {t('Allow Own Report')} */}
                                          {getValueFromResource('Allow Own Report',dispatch, t)}
                                        </th>
                                    <th className='min-w-100px text-center'>
                                        
                                        {/* {t('Allow Own Team')} */}
                                          {getValueFromResource('Allow Own Team',dispatch, t)}
                                        </th>
                                    <th className='min-w-100px text-center'>
                                        
                                        {/* {t('Allow Own Project')} */}
                                          {getValueFromResource('Allow Own Project',dispatch, t)}
                                        </th>
                                    <th className='min-w-100px text-center'>
                                        
                                        {/* {t('Allow Own Sub-Ordinates')} */}
                                          {getValueFromResource('Allow Own Sub-Ordinates',dispatch, t)}
                                        </th>
                                    <th className='min-w-100px text-center'>
                                        
                                        {/* {t('Allow Own Approval')} */}
                                          {getValueFromResource('Allow Own Approval',dispatch, t)}
                                        </th>

                                </tr>
                            </thead>
                            <tbody>
                                {accountReportPermissionList.length > 0 && accountReportPermissionList.map((accountReportPermissionDetail: any, index: any) => (
                                    <tr key={`${index}`}>
                                        <td>
                                            <span className="d-block">
                                                {accountReportPermissionDetail.Role}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="centered-container">
                                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input widget-9-check"
                                                        checked={accountReportPermissionDetail.ShowReport ? accountReportPermissionDetail.ShowReport : false}
                                                        onChange={(e) => { handleCheckboxChange(e, index, 'ShowReport') }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="centered-container">
                                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input widget-9-check"
                                                        checked={accountReportPermissionDetail.AllowCustomization ? accountReportPermissionDetail.AllowCustomization : false}
                                                        onChange={(e) => { handleCheckboxChange(e, index, 'AllowCustomization') }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="centered-container">
                                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input widget-9-check"
                                                        checked={accountReportPermissionDetail.AllowAllUser ? accountReportPermissionDetail.AllowAllUser : false}
                                                        onChange={(e) => { handleCheckboxChange(e, index, 'AllowAllUser') }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="centered-container">
                                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input widget-9-check"
                                                        checked={accountReportPermissionDetail.AllowOwnReport ? accountReportPermissionDetail.AllowOwnReport : false}
                                                        onChange={(e) => { handleCheckboxChange(e, index, 'AllowOwnReport') }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="centered-container">
                                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input widget-9-check"
                                                        checked={accountReportPermissionDetail.AllowOwnTeam ? accountReportPermissionDetail.AllowOwnTeam : false}
                                                        onChange={(e) => { handleCheckboxChange(e, index, 'AllowOwnTeam') }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="centered-container">
                                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input widget-9-check"
                                                        checked={accountReportPermissionDetail.AllowOwnProject ? accountReportPermissionDetail.AllowOwnProject : false}
                                                        onChange={(e) => { handleCheckboxChange(e, index, 'AllowOwnProject') }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="centered-container">
                                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input widget-9-check"
                                                        checked={accountReportPermissionDetail.AllowOwnSubOrdinates ? accountReportPermissionDetail.AllowOwnSubOrdinates : false}
                                                        onChange={(e) => { handleCheckboxChange(e, index, 'AllowOwnSubOrdinates') }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="centered-container">
                                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input widget-9-check"
                                                        checked={accountReportPermissionDetail.AllowOwnApproval ? accountReportPermissionDetail.AllowOwnApproval : false}
                                                        onChange={(e) => { handleCheckboxChange(e, index, 'AllowOwnApproval') }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {accountReportPermissionList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}